<template>
  <div class="five-grid-container">
    <template v-if="floorData.data.length > 0">
      <div v-for="(item, idx) in floorData.data" :key="idx" class="box-item">
        <a @click='$jumpToPage(item)' >
          <img class="item-img" :src="item.imageUrl" />
          <span class="item-title">{{item.title}}</span>
        </a>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'FiveGrids',
  props: ['floorData'],
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .five-grid-container{
    padding: .15rem 0.05rem;
    display: flex;
    .box-item{
        height: .54rem;
        width: 20%;
        a{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            .item-img{
                width: .3rem;
                height: .3rem;
            }
            .item-title{
                font-size: .12rem;
                font-family: PingFangSC, PingFangSC-Regular;
                color: #333333;
                line-height: 1.5;
            }
        }
    }
  }
</style>
